import script from "./OnboardingAiIntroStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiIntroStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiIntroStep.vue?vue&type=style&index=0&id=800c5fbc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-800c5fbc"]])

export default __exports__